import { useCallback } from 'react';
import {
  setContextualSupport as setSupport,
  unsetContextualSupport as unsetSupport,
} from 'js/actions';
import useAppDispatch from 'js/hooks/useAppDispatch';

/**
 * replace the usage of this hook with the useAppAdapter hook
 * @returns
 */
export default function useApp() {
  const dispatch = useAppDispatch();

  const setContextualSupport = useCallback((pageKey) => {
    dispatch(setSupport(pageKey));
  }, []);

  const unsetContextualSupport = useCallback((pageKey) => {
    dispatch(unsetSupport(pageKey));
  }, []);

  return {
    setContextualSupport,
    unsetContextualSupport,
  };
}
